import { Button } from '@/components/ui/button';

export function CTA() {
  return (
    <section className="py-20 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl rounded-2xl bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-16 text-center sm:px-12">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Ready to Experience Next-Generation IP AI?
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-blue-100">
            Be among the first IP professionals to access cutting-edge AI tools while keeping your
            confidential information under your control.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button
              size="lg"
              className="w-full bg-white text-blue-600 hover:bg-gray-100 sm:w-auto"
              asChild
            >
              <a href="#beta-signup">Apply for Beta Access</a>
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="w-full border-white bg-transparent text-white hover:bg-white/10 sm:w-auto"
              asChild
            >
              <a href="mailto:info@safeidea.ai?subject=Demo Request">Request a Demo</a>
            </Button>
          </div>
          <p className="mt-6 text-sm text-blue-100">
            Limited beta access • Application review required
          </p>
        </div>
      </div>
    </section>
  );
}
